import Tmdb from "../../services/tmdb";

const tmdb = new Tmdb();

export const FETCH_SIMILLIAR_REQUESTED = "FETCH_SIMILLIAR_REQUESTED";
export const SIMILLIAR_LOADED = "SIMILLIAR_LOADED";
export const SIMILLIAR_ERROR = "SIMILLIAR_LOADED";

export const similliarRequested = () => {
  return {
    type: FETCH_SIMILLIAR_REQUESTED
  };
};

export const similliarLoaded = movies => {
  return {
    type: SIMILLIAR_LOADED,
    payload: movies
  };
};

export const similliarError = () => {
  return {
    type: SIMILLIAR_ERROR
  };
};

export const fetchSimilliarMovies = movie => {
  return dispatch => {
    dispatch(similliarRequested());
    tmdb
      .getSimiliar(movie)
      .then(data => dispatch(similliarLoaded(data)))
      .catch(() => dispatch(similliarError()));
  };
};
